<template>
  <div class="transcoding-modal-layout grid grid-cols-1 gap-4 md:items-start md:gap-7">
    <section class="grid gap-5">
      <div class="grid gap-3.5 py-2.5">
        <h3 class="text-[13px] font-medium uppercase tracking-[1px] text-[#ffaa00]">Basic settings</h3>
        <bly-native-text-field
          :value="model.name"
          label="Name"
          :error="errors.name"
          required
          @input="updateRoot('name', $event)"
        />
        <bly-native-textarea-field
          :value="model.description"
          label="Description"
          @input="updateRoot('description', $event)"
        />
        <bly-native-text-field
          v-if="mode === 'create'"
          :value="model.id"
          label="ID"
          placeholder="Optional custom ID"
          @input="updateRoot('id', $event)"
        />
      </div>

      <div class="grid gap-3.5 py-2.5">
        <h3 class="text-[13px] font-medium uppercase tracking-[1px] text-[#ffaa00]">Claims</h3>
        <div class="grid gap-1">
          <span class="text-xs font-semibold text-[#dde6f3]">Access claims *</span>
          <el-cascader
            :value="model.claimsCanAccess"
            :options="claimsTree"
            :props="{ multiple: true, checkStrictly: true }"
            :show-all-levels="false"
            collapse-tags
            clearable
            class="w-full"
            @input="updateRoot('claimsCanAccess', $event)"
          />
          <span v-if="errors.claimsCanAccess" class="text-xs text-red-300">
            {{ errors.claimsCanAccess }}
          </span>
        </div>

        <div class="mt-3.5 grid gap-1">
          <span class="text-xs font-semibold text-[#dde6f3]">Edit claims *</span>
          <el-cascader
            :value="model.claimsCanEdit"
            :options="claimsTree"
            :props="{ multiple: true, checkStrictly: true }"
            :show-all-levels="false"
            collapse-tags
            clearable
            class="w-full"
            @input="updateRoot('claimsCanEdit', $event)"
          />
          <span v-if="errors.claimsCanEdit" class="text-xs text-red-300">
            {{ errors.claimsCanEdit }}
          </span>
        </div>
      </div>
    </section>

    <section class="grid gap-5">
      <div class="grid gap-3.5 py-2.5">
        <h3 class="text-[13px] font-medium uppercase tracking-[1px] text-[#ffaa00]">Transcoding configuration</h3>

        <bly-native-select-field
          :value="model.transcoding.type"
          label="Type"
          :error="errors['transcoding.type']"
          :options="typeOptions"
          required
          @input="updateTranscoding('type', $event)"
        />

        <bly-permission-field label="Config">
          <transcoding-config-editor
            v-if="entityType === 'transcodingProfile'"
            :value="model.transcoding.config"
            @input="updateTranscoding('config', $event)"
          />
          <transcoding-output-config-editor
            v-else
            :value="model.transcoding.config"
            @input="updateTranscoding('config', $event)"
            @validation-change="$emit('validation-change', $event)"
          />
        </bly-permission-field>
      </div>
    </section>
  </div>
</template>

<script>
import TranscodingConfigEditor from "@/components/Admin/TranscodingConfigEditor.vue";
import TranscodingOutputConfigEditor from "@/components/Admin/TranscodingOutputConfigEditor.vue";

export default {
  name: "TranscodingPermissionForm",
  components: {
    TranscodingConfigEditor,
    TranscodingOutputConfigEditor,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    errors: {
      type: Object,
      default: () => ({}),
    },
    mode: {
      type: String,
      default: "create",
    },
    claimsTree: {
      type: Array,
      default: () => [],
    },
    entityType: {
      type: String,
      required: true,
    },
  },
  computed: {
    model() {
      return this.value || {};
    },
    typeOptions() {
      return [{ value: "MEDIA_LIVE", label: "MediaLive" }];
    },
  },
  methods: {
    emit(nextValue) {
      this.$emit("input", nextValue);
    },
    updateRoot(field, value) {
      this.emit({
        ...this.model,
        [field]: value,
      });
    },
    updateTranscoding(field, value) {
      this.emit({
        ...this.model,
        transcoding: {
          ...(this.model.transcoding || {}),
          [field]: value,
        },
      });
    },
  },
};
</script>

<style scoped>
.transcoding-modal-layout {
  grid-template-columns: 1fr;
}

@media (min-width: 768px) {
  .transcoding-modal-layout {
    grid-template-columns: minmax(260px, 340px) minmax(0, 1fr);
  }
}
</style>
